import { getClassicVoicings, type ChordVoicingResult, type ExtendedChordQuality } from "../chordEngine";
import { parseChordName } from "../musicTheory";

export function getVoicingFromChordName(chordName: string): ChordVoicingResult | null {
  const parsed = parseChordName(chordName);
  if (!parsed) return null;
  const voicings = getClassicVoicings(parsed.root, parsed.quality as ExtendedChordQuality);
  return voicings[0] ?? null;
}
